const oidcConfigs = {
  // https://flip.t.enablo.dev
  bigboxlocal: {
    url: 'https://bigbox.enablo.com',
    clientId: 'external-oidc-flip-demos-local',
    realm: 'bigbox',
  },
  bigbox: {
    url: 'https://bigbox.enablo.com',
    clientId: 'external-oidc-flip-demos',
    realm: 'bigbox',
  },
  enablodev: {
    url: 'https://flip.enablo.dev',
    clientId: 'external-oidc-flip-demos-enablo-dev',
    realm: 'enablo',
  },
  grilld: {
    url: 'https://grilld.trials.enablo.com',
    clientId: 'external-oidc-flip-demos-grilld-deployed',
    realm: 'grilld-trial',
  },
  suntory: {
    url: 'https://suntory.trials.enablo.com',
    clientId: 'external-oidc-flip-demos',
    realm: 'suntory-trial',
  },
  suntoryeu: {
    url: 'https://suntory.testing.flip-app.com',
    clientId: 'external-oidc-flip-demos',
    realm: 'suntory',
  },
  artemis: {
    url: 'https://artemis.testing.flip-app.com',
    clientId: 'external-oidc-flip-demos-enablo-artemis-test',
    realm: 'artemis',
  },
  benjerrys: {
    url: 'https://benjerrys.trials.enablo.com',
    clientId: 'external-oidc-flip-demos',
    realm: 'benjerrys-trial',
  },
  benjerryslocal: {
    url: 'https://benjerrys.trials.enablo.com',
    clientId: 'external-oidc-flip-demos-local',
    realm: 'benjerrys-trial',
  },
  avc: {
    url: 'https://avc.trials.enablo.com',
    clientId: 'external-oidc-flip-demos',
    realm: 'avc-trial',
  },
  realnz: {
    url: 'https://realnz.trials.enablo.com',
    clientId: 'external-oidc-flip-demos',
    realm: 'realnz-trial',
  },
};

export default oidcConfigs;
